import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 30,
    seconds: 2
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-display text-white" data-id="element-56">
      <div className="flex flex-col items-center" data-id="element-57">
        <div className="bg-brand-dark border border-brand-pink/30 rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_0_15px_rgba(255,59,92,0.15)]" data-id="element-58">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs text-gray-400 mt-1 font-sans tracking-widest" data-id="element-59">
          HORAS
        </span>
      </div>
      <span className="text-brand-pink pb-5" data-id="element-60">:</span>
      <div className="flex flex-col items-center" data-id="element-61">
        <div className="bg-brand-dark border border-brand-pink/30 rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_0_15px_rgba(255,59,92,0.15)]" data-id="element-62">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs text-gray-400 mt-1 font-sans tracking-widest" data-id="element-63">
          MIN
        </span>
      </div>
      <span className="text-brand-pink pb-5" data-id="element-64">:</span>
      <div className="flex flex-col items-center" data-id="element-65">
        <div className="bg-brand-dark border border-brand-pink/30 rounded-lg px-3 py-2 min-w-[60px] md:min-w-[80px] text-center shadow-[0_0_15px_rgba(255,59,92,0.15)]" data-id="element-66">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs text-gray-400 mt-1 font-sans tracking-widest" data-id="element-67">
          SEG
        </span>
      </div>
    </div>;
}